import uiController from '../data/uicontroller.json';
import content from '../data/content.json';

class ContentService {
  constructor() {
    this.ui = uiController;
    this.content = content;
  }

  // UI Controller methods
  getAppConfig() {
    return this.ui.app_config;
  }

  getLoginConfig() {
    return this.ui.login;
  }

  getChatConfig() {
    return this.ui.chat;
  }

  getDashboardConfig() {
    return this.ui.dashboard;
  }

  // Content methods
  getTools() {
    return this.content.tools;
  }

  getSections() {
    return this.content.sections;
  }

  getTeaserCards() {
    return this.content.teaser_cards;
  }

  getCategories() {
    return this.content.categories || [];
  }

  // Dashboard-specific UI methods
  getSearchConfig() {
    return this.ui.dashboard.search;
  }

  getTeaserCardsConfig() {
    return {
      ...this.content.teaser_cards,
      ...this.ui.dashboard.teaser_cards
    };
  }

  getFloatingChatConfig() {
    return this.ui.dashboard.floating_chat;
  }

  getUserInterfaceConfig() {
    return this.ui.dashboard.user_interface;
  }

  getTypewriterConfig() {
    return this.ui.dashboard.typewriter;
  }

  getIconMapping() {
    return this.ui.dashboard.icon_mapping;
  }

  getSearchAliases() {
    return this.ui.dashboard.search_aliases;
  }

  getToolIcon(title) {
    const titleKey = title.toLowerCase().replace(/[^a-z0-9]/g, '_').replace(/_+/g, '_').replace(/^_|_$/g, '');
    const iconMap = this.getIconMapping();
    return iconMap[titleKey] || iconMap.default;
  }

  // Combined methods for convenience
  getAllUIConfig() {
    return this.ui;
  }

  getAllContent() {
    return this.content;
  }
}

export const contentService = new ContentService();